// extracted by mini-css-extract-plugin
module.exports = {"table-section":"styles_table-section__2rzwv"};